import React from 'react';
import { images } from '../../assets';
import appStoreLogo from '../../assets/images/app-store-logo.png';
import './Overview.css';
import FadeInSection from '../FadeInSection/FadeInSection';

const Overview: React.FC = () => {
  return (
    <section className="overview-section">
      <div className="overview-content">
        <div className="overview-columns">
          <div className="overview-left">
            <FadeInSection>
              <h2 className="overview-tagline">
              Sound that helps the body let go of stress
              </h2>
            </FadeInSection>
            <FadeInSection delay={300}>
              <p className="overview-description">
              Stress can trap the body in ‘Fight or Flight’ negatively impacting cortisol, and HRV leading to cellular aging.</p>
              <p className="overview-description">Heal uses music therapy & guided breathwork to provide Vagus Nerve Stimulation & a natural Cortisol Detox, helping shift your nervous system into rest and repair - often in minutes.</p>
            </FadeInSection>
            <FadeInSection delay={600}>
              <p className="overview-subtitle">Feel, listen, Heal.</p>
              <a
                href={process.env.REACT_APP_APP_STORE_URL || 'https://apps.apple.com/app/heal'}
                target="_blank"
                rel="noopener noreferrer"
                className="overview-app-store-link"
                aria-label="Download HEAL on the App Store"
              >
                <img src={appStoreLogo} alt="Download on the App Store" className="overview-app-store-logo" />
              </a>
            </FadeInSection>
          </div>
          <div className="overview-right">
            <img
              src={images.overview}
              alt="Heal app screens showing music therapy, breathwork, and HRV insights"
              className="overview-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Overview; 